module.exports = __webpack_public_path__ + "static/media/markus-spiske-2KxcdGle_FA-unsplash.a67146a2.jpg";